import isFunction from 'lodash/isFunction'

import {reducer} from '../../../reducers/helpers'
import {
  CHANGE_STEP,
  CLEAR_ON_SUCCESS,
  CLOSE_ONBOARDING,
  NO_DIRECTION,
  OPEN_ONBOARDING,
  ONBOARDING_ATTRIBUTION,
  SHOW_ONBOARDING_PASSWORD_RESET_REQUEST_FORM,
  SHOW_ONBOARDING_PASSWORD_RESET_REQUEST_SUCCESS,
  SET_REGISTERED_FLAG,
  SET_STEP,
  SUBMIT_ATTRIBUTION_SURVEY_FAILURE,
  SUBMIT_ATTRIBUTION_SURVEY_SUCCESSFUL,
  SUBMIT_ATTRIBUTION_SURVEY_PENDING,
  TOGGLE_MADLIBS_EDITING_ID,
} from './actions'

const initialState = {
  attributionAnswer: '',
  direction: '',
}

export default reducer(initialState, (state, action) => {
  const {payload, type} = action

  switch (type) {
    case CHANGE_STEP:
      return {
        direction: payload.direction,
        step: payload.step,
      }
    case CLEAR_ON_SUCCESS:
      return {
        onSuccess: undefined,
      }
    case CLOSE_ONBOARDING:
      return {
        isOpen: false,
        direction: '',
        passwordResetRequestFormIsVisible: false,
        passwordResetRequestSuccessIsVisible: false,
      }
    case NO_DIRECTION:
      return {
        direction: '',
      }
    case ONBOARDING_ATTRIBUTION:
      return {
        attributionAnswer: payload,
      }
    case OPEN_ONBOARDING:
      return {
        ...{
          isOpen: true,
        },
        ...(isFunction(payload) && {onSuccess: payload}),
      }
    case SUBMIT_ATTRIBUTION_SURVEY_PENDING:
      return {
        attributionIsProcessing: true,
      }
    case SUBMIT_ATTRIBUTION_SURVEY_SUCCESSFUL:
    case SUBMIT_ATTRIBUTION_SURVEY_FAILURE:
      return {
        attributionIsProcessing: false,
      }
    case SET_REGISTERED_FLAG:
      return {
        registeredWhenOpened: payload,
      }
    case SET_STEP:
      return {
        step: payload,
      }
    case SHOW_ONBOARDING_PASSWORD_RESET_REQUEST_FORM:
      return {
        emailInput: payload,
        direction: '',
        passwordResetRequestFormIsVisible: true,
        passwordResetRequestSuccessIsVisible: false,
        step: 0,
      }
    case SHOW_ONBOARDING_PASSWORD_RESET_REQUEST_SUCCESS:
      return {
        passwordResetRequestFormIsVisible: false,
        passwordResetRequestSuccessIsVisible: true,
      }
    case TOGGLE_MADLIBS_EDITING_ID:
      return {
        madlibsEditingId: state.madlibsEditingId === payload.id ? undefined : payload.id,
      }
    default:
      return null
  }
})
